<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import Flickity from "flickity";

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
      carousel: null,
      currentSlideIndex: null,
    };
  },
  mounted() {
    Vue.nextTick(() => {
      if (!!this.content.items && this.content.items.length > 0) {
        const cmp = this;
        this.carousel = new Flickity(this.$refs["flickity-carousel-products"], {
          draggable: ">1",
          pageDots: false,
          cellAlign: "center",
          prevNextButtons: false,
          wrapAround: true,
          imagesLoaded: true,
          arrowShape: { 
            x0: 10,
            x1: 60, y1: 50,
            x2: 65, y2: 45,
            x3: 20
          },
          on: {
            ready: function() {
              cmp.currentSlideIndex = 0;
            },
            change: function( index ) {
              cmp.currentSlideIndex = index;
            },
          }
        });
      }
    });
  },
}
</script>

<template>
  <div v-easyadmin="easyadminId" class="container-fluid py-5" :style="{'background-color': content.background_color}" :class="contentType" :id="easyadminId" list-carousel-products-component>
    <stripe-header :content="content" :opt-container-content="containerContent" v-if="content.title || content.title_composed"></stripe-header>
    <div class="position-relative my-4">
      <div class="position-absolute-center d-flex justify-content-center align-items-start" v-if="carousel">
        <div class="controls-container position-relative">
          <div class="position-absolute-center d-flex justify-content-between align-items-center mx-n5">
            <i class="far fa-3x fa-chevron-left cursor-pointer" @click="carousel.previous()"></i>
            <i class="far fa-3x fa-chevron-right cursor-pointer" @click="carousel.next()"></i>
          </div>
        </div>
      </div>
      <div class="flickity-carousel-products w-100 text-center" ref="flickity-carousel-products">
        <div
          v-for="(item, index) in content.items"
          class="flickity-carousel-products-item"
          :key="`carousel-products-slide-${index}`"
          :id="`carousel-products-slide-${index}`"
          :class="{'is-selected': index === 0, 'pb-3': content.flickity_dots}"
          :ref="`carousel-products-slide-${index}`"
        >
          <div class="position-relative w-100 ar-1by1">
            <div class="position-absolute w-100 h-100 slide-image-container d-flex justify-content-center align-items-center p-3">
              <div class="bg-contain-center slide-image" :style="{'background-image': getContentResponsiveImageURL('image', item)}"></div>
            </div>
          </div>
          <div class="product-item__title h4 py-3" v-if="item.title">{{item.title}}</div>
          <div class="product-item__description mb-2" v-if="item.description" v-html="item.description"></div>
          <a class="btn btn-puke-yellow px-4" v-if="item.button" :href="item.button.url" :target="getTarget(item.button)">{{item.button.title}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[list-carousel-products-component] {
  overflow-x: hidden;

  .controls-container {
    width: 20%;
    padding-bottom: 20%;
    color: $puke-yellow;

    i {
      z-index: 1;
    }
  }

  .flickity-carousel-products-item {
    width: 20%;
    
    .btn,
    .product-item__title,
    .product-item__description {
      opacity: 1;
      transition: all .5s;
    }

    .product-item__title {
      font-size: 26px;
    }

    .slide-image-container {
      border-radius: 100%;
      transition: all .25s;
      background-color: rgba($puke-yellow, .5);

      .slide-image {
        width: 75%;
        padding-bottom: 75%;
        transition: all .5s;
        filter: opacity(100%);
      }
    }
  }

  .flickity-carousel-products-item:not(.is-selected) {

    .slide-image-container {
      background-color: transparent;

      .slide-image {
        width: 60%;
        padding-bottom: 60%;
        filter: opacity(50%);
      }
    }

    .btn,
    .product-item__description {
      opacity: 0;
    }

    .product-item__title {
      opacity: 0.5;
      font-size: 22px;
    }
  }

  @include media-breakpoint-down(lg) {
    .controls-container {
      padding-bottom: 33.3333%;
    }
    .controls-container,
    .flickity-carousel-products-item {
      width: 33.3333%;
    }
  }

  @include media-breakpoint-down(sm) {
    .controls-container {
      display: none;
    }
    .controls-container,
    .flickity-carousel-products-item {
      width: 60%;
    }

    .flickity-viewport {
      overflow: visible;
    }

    .product-item__description {
      font-size: .85rem;
    }

    .flickity-carousel-products-item:not(.is-selected) {
      .product-item__title {
        opacity: 0;
        font-size: 26px;
      }
    }
  }
}
</style>
